import { render, staticRenderFns } from "./ModuleChangeList.vue?vue&type=template&id=388460d2&scoped=true"
import script from "./ModuleChangeList.vue?vue&type=script&lang=js"
export * from "./ModuleChangeList.vue?vue&type=script&lang=js"
import style0 from "./ModuleChangeList.vue?vue&type=style&index=0&id=388460d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388460d2",
  null
  
)

export default component.exports